module.exports = __webpack_public_path__ + "img/img (53).03757c6a.jpg";